import { render, staticRenderFns } from "./NetaNewAttractionComponent.vue?vue&type=template&id=3451167c&"
import script from "./NetaNewAttractionComponent.vue?vue&type=script&lang=js&"
export * from "./NetaNewAttractionComponent.vue?vue&type=script&lang=js&"
import style0 from "./NetaNewAttractionComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports